import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Option } from '@/lib/v2/components';

import { STEP_THREE_OPTIONS } from '@/src/modules/IntegrationsModule/constants';
import {
  OPTION_ONE,
  OPTION_TWO,
} from '@/src/modules/IntegrationsModule/screens/CreateOrEditIntegrationScreen/components/Steps/StepOne';

export const useStepsOptions = () => {
  const { t } = useTranslation();

  const optionsStepOne = useMemo<Option[]>(() => {
    return [
      {
        id: 'one',
        name: t('StepOne.optionOne') as unknown as string,
        value: OPTION_ONE,
      },
      {
        id: 'two',
        name: t('StepOne.optionTwo') as unknown as string,
        value: OPTION_TWO,
      },
    ];
  }, [t]);

  const optionsStepThree = useMemo<Option[]>(() => {
    return [
      {
        id: 'one',
        name: t('StepThree.select.option1'),
        value: STEP_THREE_OPTIONS.NOTHING,
      },
      {
        id: 'two',
        name: t('StepThree.select.option2'),
        value: STEP_THREE_OPTIONS.GROUPS,
      },
    ];
  }, [t]);

  return {
    optionsStepOne,
    optionsStepThree,
  };
};
